<template>
    <span>
      <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col md="9">
                    <h3>Usuários Voluntários</h3>
                    <p>Olá Tutor! Abaixo, segue a lista de voluntários inscritos no seu município para que sejam avaliados. A avaliação será feita da seguinte forma: o voluntário que ainda não foi validado estará na situação "Cadastrado". O voluntário que tiver sido capacitado com êxito, terá a sua situação alterada para "Aprovado". O voluntário que não teve êxito na sua capacitação, deverá ser "Reprovado".</p>
                 </b-col>
                 <b-col md="3">
                    <p><b>Nome:</b> {{usuario.nome}}</p>
                    <p><b>Perfil:</b> {{usuarioLogado.perfil}}</p>
                    <p><b>Estado:</b> {{usuarioLogado.estado}}</p>
                    <p><b>Município:</b> {{usuarioLogado.municipio}}</p>
                 </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
            <b-row>
                <b-col sm="12">
                    <b-form-group label="Nome, E-mail:">
                        <b-form-input type="text" id="name" v-model="filtros.filter" placeholder="Nome, E-mail"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
          <b-col md="2">
            <b-button @click="limpafiltro" block variant="cinza">
              <i class="fa fa-eraser"></i>
              <span>Limpar filtros</span>
            </b-button>
          </b-col>
          <b-col md="2">
            <b-button @click="pesquisar" block variant="primary">
              <i class="fa fa-search"></i>
              <span>Pesquisar</span>
            </b-button>
          </b-col>
        </b-row>
        </b-card-body>
        <b-row>
            <b-col sm="12">
                <b-container fluid>
                       <span>
                          <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7" class="table table-responsive-sm table-bordered table-striped table-sm">
                          <thead>
                            <tr>
                              <th scope="col">Usuário</th>
                              <th scope="col">E-mail</th>
                              <th scope="col">CPF</th>
                              <th scope="col">Situação</th>
                              <th scope="col">Ações</th>
                            </tr>
                          </thead>
                          <tbody v-if="usuarios.data !== undefined">
                            <tr v-for="usuario in usuarios.data" :key="usuario.id">
                              <td>{{usuario.nome}}</td>
                              <td>{{usuario.email}}</td>
                              <td>{{usuario.cpf}}</td>
                              <td>
                                <span v-if="usuario.voluntario_situacao === 'CADASTRADO'" class="badge badge-info">C A D A S T R A D O</span>
                                <span v-if="usuario.voluntario_situacao === 'EM_CAPACITACAO'" class="badge badge-warning">E M&nbsp;&nbsp;&nbsp;&nbsp;C A P A C I T A Ç Ã O</span>
                                <span v-if="usuario.voluntario_situacao === 'APROVADO'" class="badge badge-success">A P R O V A D O</span>
                                <span v-if="usuario.voluntario_situacao === 'REPROVADO'" class="badge badge-danger">R E P R O V A D O</span>
                              </td>
                              <td style="width: 15%">
                                  <a v-if="usuario.voluntario_situacao === 'CADASTRADO'" class="btn btn-sm btn-secondary action" title="Em capacitação" @click="capacitarVoluntario(usuario.id)">
                                   <i class="fa fa-star"></i>
                                  </a>
                                  <a v-if="usuario.voluntario_situacao === 'EM_CAPACITACAO' || usuario.voluntario_situacao === 'REPROVADO'" class="btn btn-sm btn-secondary action" title="Aprovar" @click="aprovarVoluntario(usuario.id)">
                                   <i class="fa fa-thumbs-o-up"></i>
                                  </a>
                                  <a v-if="usuario.voluntario_situacao === 'EM_CAPACITACAO' || usuario.voluntario_situacao === 'APROVADO'" class="btn btn-sm btn-secondary action" title="Reprovar" @click="reprovarVoluntario(usuario.id)">
                                   <i class="fa fa-thumbs-o-down"></i>
                                  </a>
                              </td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                           <tr class="action">
                             <td colspan="7">Nenhum registro de usuários...</td>
                           </tr>
                          </tbody>
                         </table>
                         <pagination v-show="usuarios.data !== undefined" :totalPorPagina="totalPorPagina" :resource="resource"></pagination>
                       </span>
                </b-container>
            </b-col>
        </b-row>
      </b-card>
    </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import {eventType} from '@/components/shared/eventType'
import SessionStorage from '@/services/session-storage'
import miniToastr from 'mini-toastr'

miniToastr.init()

export default {
  components: {
    Pagination
  },
  created () {
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') !== 'I') {
      this.$router.push('/')
    }

    this.$store.dispatch('buscarTipoUsuarios')
    this.$store.dispatch('buscarEstados')
    this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
  },
  data () {
    return {
      usuarioLogado: {
        municipio: '',
        estado: '',
        perfil: ''
      },
      usuarioCorrente: parseInt(SessionStorage.get('usuario')),
      totalPorPagina: 5,
      resource: 'usuario/voluntarios',
      filtros: {
        filter: '',
        apenasVoluntarios: true
      }
    }
  },
  mounted () {
    this.setarFiltros(this.filtros)
  },
  computed: {
    usuarios () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    }
  },
  watch: {
    'usuario.dados_pessoais.cidade': function () {
      this.usuarioLogado.municipio = this.usuario.dados_pessoais.cidade.cidade
    },
    'usuario.dados_pessoais.cidade.estado': function () {
      this.usuarioLogado.estado = this.usuario.dados_pessoais.cidade.estado.estado
    },
    'usuario.perfil': function () {
      this.usuarioLogado.perfil = this.usuario.perfil.nome
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    pesquisar () {
      this.$store.dispatch('getRegistrosSearch', {
        resource: this.resource,
        limit: this.totalPorPagina,
        filtros: this.filtros
      })
      this.setarFiltros(this.filtros)
    },
    limpafiltro () {
      this.filtros = {
        filter: '',
        apenasVoluntarios: true
      }
      this.pesquisar()
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    navigate (route) {
      this.$router.push(route)
    },
    aprovarVoluntario (id) {
      this.$bvModal.msgBoxConfirm('Confirma que o registro selecionado foi aprovado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.get('api/usuario/aprovarVoluntario/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
          this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
        }
      })
    },
    reprovarVoluntario (id) {
      this.$bvModal.msgBoxConfirm('Confirma que o registro selecionado foi reprovado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.get('api/usuario/reprovarVoluntario/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
          this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
        }
      })
    },
    capacitarVoluntario (id) {
      this.$bvModal.msgBoxConfirm('Confirma que o registro selecionado se encontra em capacitação?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.get('api/usuario/capacitarVoluntario/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
          this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
        }
      })
    }

  }
}
</script>

<style scoped>
    .action{
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/usuarios/UsuariosVoluntarios.vue